import React from 'react';

export const Bell: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      d="M10 19a1.848 1.848 0 001.882-1.8H8.118A1.848 1.848 0 0010 19zm6.118-5.4V8.65a5.853 5.853 0 00-4.706-5.67v-.63a1.413 1.413 0 00-2.824 0v.63a5.853 5.853 0 00-4.706 5.67v4.95L2 15.4v.9h16v-.9z"
      fill="currentColor"
    />
  </svg>
);
